import { enumLabel } from '@gasbi/shared/common/features';
import { GasPipelineSectionReadSlim } from '@gasbi/shared/common/features/gasPipelineSections/types';
import { HeaderWithUnits } from '@gasbi/shared/web/components';
import i18n from 'i18next';

import { BaseTypography } from '@/components/BaseStyledComponents/BaseTypography';
import { getFormattedDate } from '@/utils/getFormattedDate';

import { GridSortModel } from '@mui/x-data-grid-pro';
import { GridColDef } from '@mui/x-data-grid-pro';

import Table from '@components/Table';

interface PipelineSectionsTableProps {
  sections: GasPipelineSectionReadSlim[];
  isLoading: boolean;
}

const columns: GridColDef<GasPipelineSectionReadSlim>[] = [
  {
    field: 'number',
    headerName: '№',
    width: 70,
    sortable: false,
  },
  {
    field: 'type',
    headerName: 'Тип',
    flex: 1,
    valueGetter: (value: GasPipelineSectionReadSlim['type']) =>
      value?.name || '-',
    sortable: false,
  },
  {
    field: 'placing',
    headerName: 'Розташування',
    flex: 1,
    valueGetter: (value: GasPipelineSectionReadSlim['placing']) =>
      enumLabel(i18n.t, 'GasPipelineSectionsLocation', value) || '-',
    sortable: false,
  },
  {
    field: 'pressureCategory',
    headerName: 'Категорія тиску',
    flex: 1,
    valueGetter: (value: GasPipelineSectionReadSlim['pressureCategory']) =>
      enumLabel(i18n.t, 'PressureCategory', value) || '-',
    sortable: false,
  },
  {
    field: 'length',
    renderHeader: () => <HeaderWithUnits text='Довжина' unit='м' />,
    flex: 1,
    valueGetter: value => value ?? '-',
    sortable: false,
  },
  {
    field: 'initialDate',
    headerName: 'Первинне введення',
    flex: 1,
    valueFormatter: value => getFormattedDate(value),
    sortable: false,
  },
];

const sortModel: GridSortModel = [];

export const PipelineSectionsTable = ({
  sections,
  isLoading,
}: PipelineSectionsTableProps) => {
  return (
    <>
      <BaseTypography level='title-sm' fontWeight={600}>
        Ділянки газопроводу
      </BaseTypography>

      <Table
        rows={sections}
        columns={columns}
        getRowId={row => row.id}
        sortModel={sortModel}
        loading={isLoading}
      />
    </>
  );
};
